import { jsx } from "react/jsx-runtime";
import "react";
import { Badge, Box, Image } from "pcln-design-system";
import styled_components from "styled-components";
const BadgeWrapper = /*#__PURE__*/ styled_components(Badge).withConfig({
    displayName: "ExpressDealBadge__BadgeWrapper"
})([
    "position:absolute;top:12px;left:12px;"
]);
const RelativeBox = /*#__PURE__*/ styled_components(Box).withConfig({
    displayName: "ExpressDealBadge__RelativeBox"
})([
    "position:relative;"
]);
const ExpressDealBadge = ()=>/*#__PURE__*/ jsx(RelativeBox, {
        children: /*#__PURE__*/ jsx(BadgeWrapper, {
            bg: "background.lightest",
            children: /*#__PURE__*/ jsx(Image, {
                height: 12,
                src: "https://s1.pclncdn.com/design-assets/brand-assets/express-deal-logo-tm.svg"
            })
        })
    });
const ExpressDealBadge_ExpressDealBadge = ExpressDealBadge;
export { ExpressDealBadge, ExpressDealBadge_ExpressDealBadge as default };
